import { BarChart3, Loader2 } from 'lucide-react';
import EmptyView from '@/shared/components/EmptyView';
import { useServiceLineUsage } from '../services/account-service-lines';
import { DailyDataUsageBarChart } from '@/shared/components/DailyDataUsageBarChart';
import { format, parseISO } from 'date-fns';

interface ServiceLineDailyUsageSectionProps {
    serviceLineNumber: string;
    startDate: string;
}

export function ServiceLineDailyUsageSection({ serviceLineNumber, startDate }: ServiceLineDailyUsageSectionProps) {
    const month = format(parseISO(startDate), 'yyyy-MM');

    const { data: dataUsages, isLoading } = useServiceLineUsage(
        serviceLineNumber,
        month,
    );

    const dailyDataUsages = dataUsages?.find((usage) => format(parseISO(usage.startDate), 'yyyy-MM') === month)?.dailyDataUsages || [];

    return (
        <div className="w-full flex items-center justify-center h-full">
            {isLoading ? (
                <Loader2 className="h-5 w-5 animate-spin" />
            ) : (
                dailyDataUsages.length > 0 ? (
                    <div className="w-full overflow-hidden rounded-lg border bg-background p-4">
                        <DailyDataUsageBarChart dataUsages={dailyDataUsages} />
                    </div>
                ) : <EmptyView
                    icon={BarChart3}
                    size="medium"
                    title="No Daily Usage Data Available"
                    description="There is no daily usage data available for this month"
                />
            )}
        </div>
    );
}
